<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑分类' : '添加分类'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="所属行业" prop="industry_id">
				<template>
					<el-select v-model="item.industry_id" filterable placeholder="请选择">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</template>
			</el-form-item>
			<el-form-item label="上级分类" v-if="store && store.product_category_level != 1">
				<div class="block">
					<el-cascader v-model="item.parent_id" placeholder="不选择则作为一级分类" :options="optionsParent"
						:props="filterProps" clearable></el-cascader>
				</div>
			</el-form-item>
			<el-form-item label="分类名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入分类名称" class="el-input-default-width-220"></el-input>
			</el-form-item>

			<el-form-item label="排序号" prop="orders">
				<el-input v-model="item.orders" placeholder="请输入排序号" class="el-input-default-width-220"></el-input>
			</el-form-item>
			<el-form-item label="分类图标" prop="logo">
				<el-input v-model="item.logo" type="hidden"></el-input>
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('logo', value)"
						:show-file-list="false"
						:action="app_url + '/store/uploader/upload'">
					<div class="icon" v-if="!item.logo">
						<i class=" el-icon-plus" ></i>
						<span>图片规格：154px x 154px</span>
					</div>
					<img :src="item.logo" v-else>
				</el-upload>
			</el-form-item>

			<el-form-item label="副标题">
				<el-input v-model="item.sub_name" placeholder="请输入副标题"></el-input>
			</el-form-item>

			<div>
				<el-form-item label="推荐至首页快捷导航">
					<el-switch :active-value="1" inactive-value="0" v-model="item.is_to_main" active-color="#13ce66"></el-switch>
				</el-form-item>
				<el-form-item label="推荐至首页tab页">
					<el-switch :active-value="1" inactive-value="0" v-model="item.is_to_hot" active-color="#13ce66"></el-switch>
				</el-form-item>
			</div>

			<el-form-item label="分类广告图">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('advertising', value)"
						:show-file-list="false"
						:action="app_url + '/store/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.advertising"></i>
					<img :src="item.advertising" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {
					orders: 1,
					is_to_main: 1,
					is_to_hot: 0,
					logo: ''
				},
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				logo: [],
				advertising: [],
				optionsParent: [],
				options: [],
				optionsStore: [],
				rules: {
					industry_id: [
					    {required: true, message: '所属行业：不能为空', trigger: 'blur'},
					],
					name: [
					    {required: true, message: '分类名称：不能为空', trigger: 'blur'},
					],
					logo: [
					    {required: true, message: '分类图标：不能为空', trigger: 'blur'},
					],
					orders: [
					    {required: true, message: '排序号：不能为空', trigger: 'blur'},
					],
				},
				store: null,
			}
		},

		created() {
			this.loadStore()
			this.loadData()
		},
		methods: {
			loadStore: function () {
				this.axios.post('/store/index/store', this.item)
				.then(res => {
					this.store = res.data.store
				})
			},
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ''
				// 所属行业的信息
				res = await this.axios.get('/store/data/listIndustryForSelect', {})
				this.options = res.data.list
				// 上级分类的树形信息
				res = await this.axios.get('/store/data/getCategoryStore', {})
				this.optionsParent = res.data.list

				// 获取商品分类信息
				if (this.id) {
					res = await this.axios.post('/store/productCategory/detail', {
						id: this.id
					})
					this.item = res.data.detail
				}
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				if (this.item.parent_id) {
					if (this.item.parent_id.length > 0) {
						this.item.parent_id = this.item.parent_id[this.item.parent_id.length - 1]
					}
				} else {
					this.item.parent_id = 0
				}

				let url = ''
				if (this.id) {
					url = '/store/productCategory/update'
					this.item.id = this.id
					this.axios.put(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				} else {
					url = '/store/productCategory/add'
					this.axios.post(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				}
			},
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
				this.$forceUpdate()
			},
			uploadSuccessAdvertising(res, file, fileList) {
				for (let key in fileList) {
					let item = fileList[key]
					if (item.response)
						item.name = item.response.data.src
				}
				this.advertising = fileList
				this.$message.success({
					message: '上传成功'
				});
			},
			uploadRemoveAdvertising: function(file, fileList) {
				this.advertising = fileList
			},
		}
	}
</script>
<style scoped>
</style>
